import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-595ef2f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "minecraft" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-4" }, "Minecraft Terminal", -1))
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Map: "),
  /*#__PURE__*/_createElementVNode("a", { href: "http://54.203.168.174:8123" }, "Click here!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["buttons mb-4", { 'disabled-container': _ctx.disabled }])
    }, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)))
      }, "Start"),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
      }, "Stop")
    ], 2),
    _createElementVNode("span", _hoisted_3, "Message: " + _toDisplayString(_ctx.message), 1),
    _hoisted_4
  ]))
}